import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';
import userTypesReducer from './userTypesSlice';
import departmentsReducer from './departmentsSlice';
import schoolsReducer from './schoolsSlice';
import supportsReducer from './supportSlice';
import IPStatusReducer from './ipStatusesSlice';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
  user: userReducer,
  userTypes: userTypesReducer,
  departments: departmentsReducer,
  schools: schoolsReducer,
  support_or_partnership: supportsReducer,
  ip_statuses: IPStatusReducer,
});

const persistConfig = {
  key: 'built',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
